import { render, staticRenderFns } from "./ProjectStaffView.vue?vue&type=template&id=d6020f0e&scoped=true&"
import script from "./ProjectStaffView.vue?vue&type=script&lang=js&"
export * from "./ProjectStaffView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6020f0e",
  null
  
)

export default component.exports